import * as React from "react";
import classnames from "classnames";
import "./styles.scss";

export interface IProps {
  title?: string;
  onSubmit?: () => void;
  active?: boolean;
  cancellable?: boolean;
  submitTitle?: string;
  cancelTitle?: string;
  onClose?: () => void;
  large?: boolean;
  small?: boolean;
  xLarge?: boolean;
  bodyStyle?: object;
  disableSubmit?: boolean;
  disableFooter?: boolean;
  titleBarBgColor?: string;
  titleFontColor?: string;
}

class Modal extends React.Component<IProps, any> {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public handleClose() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  public handleSubmit() {
    if (this.props.onSubmit) {
      this.props.onSubmit();
    }
  }

  public render() {
    return (
        <div className={classnames("modal", {in: this.props.active})} role="dialog">
          <div
              className={classnames("modal-dialog modal-open-zoom", {
                "modal-lg": this.props.large,
                "modal-sm": this.props.small,
                "modal-x-lg": this.props.xLarge,
              })} role="document">
            <div className="modal-content">
              {this.props.title &&
              <div className="modal-header"
                   style={{background: `${this.props.titleBarBgColor ? this.props.titleBarBgColor : "white"}`,
                     color: `${this.props.titleFontColor ? this.props.titleFontColor : "#f5821f"}`,
                     borderBottom: "none",
                   }}>
                <h4 className="modal-title">{this.props.title}</h4>
                {this.props.cancellable &&
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this.handleClose}>
                  <span aria-hidden="true">&times;</span>
                </button>
                }
              </div>
              }
              <div className="modal-body" style={this.props.bodyStyle}>
                {this.props.children}
              </div>
              {(this.props.onSubmit || this.props.cancellable) && !this.props.disableFooter &&
              <div className="modal-footer" style={{borderTop: "none"}}>
                {this.props.cancellable &&
                <button
                    type="button"
                    className="btn btn-default"
                    data-dismiss="modal"
                    onClick={this.handleClose}>
                  {this.props.cancelTitle || "Close"}
                </button>
                }
                {this.props.onSubmit &&
                <button
                    type="button"
                    className="btn btn-primary"
                    disabled={this.props.disableSubmit}
                    onClick={this.handleSubmit}>
                  {this.props.submitTitle || "Submit"}
                </button>
                }
              </div>
              }
            </div>
          </div>
        </div>
    );
  }
}

export default Modal;
